<template>
  <div class="specification row no-gutters">
    <div class="col-12">

      <div class="specification__title">
        SPECIFICATIONS
      </div>

      <div class="specification__content">
        <div v-for="(item, index) in attributes" :key="index" v-if="item.value">
          <div class="specification__content__title">
            {{item.label}}
          </div>
          <div class="specification__content__text">
            {{item.value}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import keys from 'lodash/keys'
import get from 'lodash/get'

export default {
  name: 'specification',
  props: {
    properties: {
      type: Object,
      default: {},
    },
  },
  computed: {
    attributes() {
      const firstKey = keys(this.properties)[0] || ''
      const attributes = this.properties[firstKey] || {}
      return get(attributes, 'attributes')
    },
  },
}
</script>

<style lang="scss">
.specification {
  font-family: $roboto;

  &__title {
    font-family: $barlow;
    font-weight: bold;
    color: $rose;
    line-height: 26px;
    text-transform: uppercase;
    font-size: rem-calc(20);
  }

  &__content {
    color: $specification-grey;
    margin-top: 22px;
    font-size: rem-calc(18);

    @include respond-to('desktop') {
      margin-top: 5px;
    }

    &>div:last-child {
      margin-bottom: 20px;
    }

    &__title {
      text-transform: capitalize;
      font-weight: bold;
      line-height: 24px;
      margin-top: 20px;

      @include respond-to('desktop') {
        line-height: 15px;
        margin-top: 14px;
        font-size: rem-calc(12);
      }

      &:after {
        content: ':';
        margin-left: -3px;
      }
    }

    &__text {
      line-height: 24px;

      @include respond-to('desktop') {
        line-height: 18px;
        font-size: rem-calc(14);
      }
    }
  }

  .col-12 {
    @include respond-to('desktop') {
      max-width: rem-calc(240);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Specification.vue?4a52375b